/**
 * 홈페이지 서비스 안내 섹션 컴포넌트
 * 4개의 주요 서비스 바로가기를 표시합니다.
 */

import { Link } from 'react-router-dom';
import styled from 'styled-components';

// 이미지 import
// import care1Img from '../../assets/care1.png';
// import care2Img from '../../assets/care2.png';
// import care3Img from '../../assets/care3.png';
// import care4Img from '../../assets/care4.png';

import care1Img from '../../assets/newImage/care1.svg';
import care2Img from '../../assets/newImage/care2.svg';
import care3Img from '../../assets/newImage/care3.svg';
import care4Img from '../../assets/newImage/care4.svg';
import care5Img from '../../assets/newImage/care5.svg';
import care6Img from '../../assets/newImage/care6.svg';
import care7Img from '../../assets/newImage/care7.svg';

// 서비스 데이터
const SERVICES = [
  { id: 1, image: care1Img, label: '장애인활동지원', path: '/care/1' },
  { id: 2, image: care2Img, label: '노인장기요양', path: '/care/2' },
  { id: 3, image: care3Img, label: '가사간병', path: '/care/3' },
  { id: 4, image: care4Img, label: '돌봄SOS', path: '/care/4' },
  { id: 5, image: care5Img, label: '사회주택', path: '/care/5' },
  { id: 6, image: care6Img, label: '사회연대경제', path: '/care/6' },
  { id: 7, image: care7Img, label: '디지털사회혁신', path: '/care/7' },
];

/**
 * ServiceQuickSection 컴포넌트
 * 장애인활동지원, 노인장기요양서비스, 가사간병방문지원서비스, 돌봄SOS서비스 바로가기
 */
function ServiceQuickSection() {
  return (
    <ServiceQuick>
      <SectionTitle>서비스안내</SectionTitle>

      <CareList>
        {SERVICES.map((service) => (
          <ServiceItem key={service.id}>
            <ServiceLink to={service.path}>
              <ServiceImage src={service.image} alt={service.label} />
              <ServiceLabel>{service.label}</ServiceLabel>
            </ServiceLink>
          </ServiceItem>
        ))}
      </CareList>
    </ServiceQuick>
  );
}

export default ServiceQuickSection;

/* Styled Components */

/* 공통 박스 스타일 */
const ServiceBox = styled.div`
  /* 데스크톱 기본 스타일 */
  position: relative;
  flex: 1;

  border: 1px solid #d7d7d7;
  font-family: 'Nanum Gothic Bold';
  box-sizing: border-box;
  padding: 20px 22px 12px;
  display: flex;
  flex-direction: column;

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    width: 100%;
    height: auto;
    border: none;
    border-top: 1px solid #f0f0f0;
    padding: 21px 0 25px 0;
  }
`;

const ServiceQuick = styled(ServiceBox)`
  flex: 1.45;

  overflow: visible;
`;

/* 공통 타이틀 스타일 */
const BoxTitle = styled.h3`
  /* 데스크톱 기본 스타일 */
  font-size: 20px;
  font-weight: bold;
  color: #e5857c;
  font-family: 'Nanum Gothic Bold';
  margin: 0 0 5px 0;

  /* 모바일 스타일 */
  @media (max-width: 1023px) {
    padding-left: 6%;
    font-size: 20px;
  }

  @media (max-width: 375px) {
    font-size: 18px;
  }

  @media (max-width: 320px) {
    font-size: 16px;
  }

  @media (min-width: 425px) and (max-width: 1023px) {
    font-size: 21px;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    font-size: 22px;
  }
`;

const SectionTitle = styled(BoxTitle)``;

const CareList = styled.ul`
  /* 데스크톱 기본 스타일 */
  width: 100%;
  list-style: none;
  padding: 0;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 8px;

  /* 모바일 스타일 (375px 미만만 2열) */
  @media (max-width: 374px) {
    width: 84%;
    margin-left: 8%;
    gap: 10px;
  }

  /* 375px 이상은 PC처럼 한 줄 */
  @media (min-width: 375px) and (max-width: 1023px) {
    width: 84%;
    margin-left: 8%;
    gap: 8px;
  }
`;

const ServiceItem = styled.li`
  /* 데스크톱 기본 스타일: 4열 */
  display: flex;
  flex: 1;

  margin: 0;
  min-width: calc(20% - 5px);

  /* 375px 미만: 2열 */
  @media (max-width: 374px) {
    min-width: calc(50% - 5px);
  }

  /* 375px ~ 1023px: 4열 (PC와 동일) */
  @media (min-width: 375px) and (max-width: 1023px) {
    min-width: calc(25% - 6px);
  }
`;

const ServiceLink = styled(Link)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;
  text-decoration: none;
  border-radius: 10px;
  background-color: #f4f4f4;
  transition: all 0.3s ease;
  padding: 15px;

  &:hover {
    background-color: #fff0ee;
    transform: translateY(-3px);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  }

  &:active {
    transform: translateY(0);
  }
`;

const ServiceImage = styled.img`
  width: 60px;
  height: 60px;
  object-fit: contain;
  margin-bottom: 8px;

  /* 모바일 스타일 */
  @media (max-width: 374px) {
    width: 50px;
    height: 50px;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    width: 55px;
    height: 55px;
  }
`;

const ServiceLabel = styled.span`
  font-size: 13px;
  font-family: 'Nanum Gothic Bold';
  color: #333333;
  text-align: center;
  word-break: keep-all;

  /* 모바일 스타일 */
  @media (max-width: 374px) {
    font-size: 11px;
  }

  @media (min-width: 768px) and (max-width: 1023px) {
    font-size: 14px;
  }
`;
